{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0, 1, 2, 3, 4]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube",
			"rotation": [-0.06674586981534958, 0.2038237303495407, -0.09014298766851425, 0.9725611209869385],
			"scale": [1.7777897119522095, 3.289381980895996, 3.289381980895996],
			"translation": [0, 2.8065927028656006, 0]
		},
		{
			"mesh": 1,
			"name": "Cube.001",
			"scale": [0.24962952733039856, 0.24962952733039856, 0.24962952733039856],
			"translation": [-0.07918600738048553, 0, 3.3376033306121826]
		},
		{
			"mesh": 2,
			"name": "Cube.002",
			"scale": [0.24962952733039856, 0.24962952733039856, 0.24962952733039856],
			"translation": [2.977968215942383, 0, 2.5803706645965576]
		},
		{
			"mesh": 3,
			"name": "Cube.003",
			"scale": [0.24962952733039856, 0.24962952733039856, 0.24962952733039856],
			"translation": [0.5284368991851807, 0, -3.936290740966797]
		},
		{
			"mesh": 4,
			"name": "Cube.004",
			"scale": [0.24962952733039856, 0.24962952733039856, 0.24962952733039856],
			"translation": [-3.1523032188415527, 0, -2.070328950881958]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.001",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.14345639944076538, 0.0451614186167717, 0.006090801674872637, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.003",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.2765146791934967, 0.08278857171535492, 0.006658048368990421, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Cube",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				}
			]
		},
		{
			"name": "Cube.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 11,
					"material": 0
				}
			]
		},
		{
			"name": "Cube.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 12,
						"NORMAL": 13,
						"TEXCOORD_0": 14
					},
					"indices": 11,
					"material": 0
				}
			]
		},
		{
			"name": "Cube.003",
			"primitives": [
				{
					"attributes": {
						"POSITION": 15,
						"NORMAL": 16,
						"TEXCOORD_0": 17
					},
					"indices": 18,
					"material": 0
				}
			]
		},
		{
			"name": "Cube.004",
			"primitives": [
				{
					"attributes": {
						"POSITION": 19,
						"NORMAL": 20,
						"TEXCOORD_0": 21
					},
					"indices": 22,
					"material": 0
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 102,
			"max": [1.080114722251892, -0.11695526540279388, 1.087493658065796],
			"min": [-1, -0.40266430377960205, -1.1022703647613525],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 102,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 102,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 156,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 30,
			"max": [1.080114722251892, -0.13638697564601898, 1.087493658065796],
			"min": [-1, -0.3834265470504761, -1.1022703647613525],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 30,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 30,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 48,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 24,
			"max": [1, 8.421229362487793, 1.5733798742294312],
			"min": [-1.1743037700653076, -0.9999999403953552, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5123,
			"count": 36,
			"type": "SCALAR"
		},
		{
			"bufferView": 12,
			"componentType": 5126,
			"count": 24,
			"max": [-0.9193439483642578, 6.4345784187316895, 2.1641578674316406],
			"min": [-6.107923984527588, -1.0970085859298706, -1.7327830791473389],
			"type": "VEC3"
		},
		{
			"bufferView": 13,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 14,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 15,
			"componentType": 5126,
			"count": 24,
			"max": [-1.2419531345367432, 4.038603782653809, 4.988889217376709],
			"min": [-3.7911462783813477, -1.1178747415542603, 0.9259911179542542],
			"type": "VEC3"
		},
		{
			"bufferView": 16,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 17,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 18,
			"componentType": 5123,
			"count": 36,
			"type": "SCALAR"
		},
		{
			"bufferView": 19,
			"componentType": 5126,
			"count": 24,
			"max": [3.429100275039673, 6.592485427856445, 2.281583070755005],
			"min": [-0.3628927767276764, -1.0787317752838135, 0.0260789692401886],
			"type": "VEC3"
		},
		{
			"bufferView": 20,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 21,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 22,
			"componentType": 5123,
			"count": 36,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 1224,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1224,
			"byteOffset": 1224,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 816,
			"byteOffset": 2448,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 312,
			"byteOffset": 3264,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 360,
			"byteOffset": 3576,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 360,
			"byteOffset": 3936,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 240,
			"byteOffset": 4296,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 96,
			"byteOffset": 4536,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 4632,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 4920,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 5208,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 72,
			"byteOffset": 5400,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 5472,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 5760,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 6048,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 6240,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 6528,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 6816,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 72,
			"byteOffset": 7008,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 7080,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 7368,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 7656,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 72,
			"byteOffset": 7848,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 7920,
			"uri": "table.bin"
		}
	]
}
